











import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import List from '@/views/document/section/List.vue';
import dokument from '@/store/modules/dokument';
import {ListSection} from '@/store/models';

@Component({components: {List}})
export default class TypedList extends Vue {
  @Prop() readonly group!: any;

  @Watch('section', {immediate: true, deep: true})
  onData() {
    if (this.group.Hidden !== this.hidden) {
      const g = {
        Id: this.group.Id,
        Kind: this.group.Kind,
        Type: this.group.Type,
        SubType: this.group.SubType,
        Children: this.group.Children,
        Hidden: this.hidden,
      };
      dokument.updateItem(g);
    }
  }

  get section(): ListSection {
    return dokument.getItems(this.group.Id)[0] as ListSection;
  }

  get hidden(): boolean {
    if (this.section.Title) {
      return false;
    }
    return !this.section.Items || this.section.Items.filter((x: any) => x.Value).length === 0;
  }
}
